import { Check } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useTranslation } from '@/hooks/useTranslation';

export type CompanyFieldProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  /** Filled from the user's profile: locked, with the "auto-filled" badge. */
  autoFilled: boolean;
  required?: boolean;
};

/** Company of the tool forms: the user's own, locked once known from the profile. */
export function CompanyField({
  id,
  value,
  onChange,
  autoFilled,
  required = true,
}: CompanyFieldProps) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{t('traceability.workshop.toolForm.fields.company.label')}</Label>
      <div className="flex items-center gap-2">
        <Input
          id={id}
          type="text"
          placeholder={t('traceability.workshop.toolForm.fields.company.placeholder')}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          disabled={autoFilled}
          required={required}
          className={autoFilled ? 'bg-muted text-muted-foreground' : undefined}
        />
        {autoFilled && (
          <Badge tone="primary">
            <Check className="h-3 w-3" aria-hidden />
            {t('traceability.workshop.toolForm.fields.company.autoFilled')}
          </Badge>
        )}
      </div>
    </div>
  );
}
